/* eslint-disable max-len */

/*  Admin Hub  */
import { AdminApplication } from 'application/Home/Admin/Application/Dashboard';
import { AdminApplications } from 'application/Home/Admin/Applications/Dashboard';
import AdminBulkEditor from 'application/Home/Admin/BulkEditor/BulkEditor';
import { AdminContractsDashboard } from 'application/Home/Admin/Contracts/Dashboard';
import Domains from 'application/Home/Admin/Domains/Containers/Dashboard';
import { AdminExtension } from 'application/Home/Admin/Extension/Extension';
import ProviderIntegration from 'application/Home/Admin/Integrations/Dashboard';
import AdminLogs from 'application/Home/Admin/Logs/Logs';
import AdminNotes from 'application/Home/Admin/Notes/Dashboard';
import { Pathfinder } from 'application/Home/Admin/Pathfinder';
import { TagEditor } from 'application/Home/Admin/TagEditor/TagEditor';
import { AdminUserDashboard } from 'application/Home/Admin/User/Dashboard';
import { AdminProvider } from 'application/Home/Admin/Users/AdminProvider';
import { AdminUsersAccounts } from 'application/Home/Admin/Users/AdminUsersAccounts';
import { AdminUsersDevices } from 'application/Home/Admin/Users/Devices';
import ProviderGroups from 'application/Home/Admin/Users/ProviderGroups';
import ProviderUsers from 'application/Home/Admin/Users/ProviderUsers';
import { AdminUsers } from 'application/Home/Admin/Users/Users';
import { AdminUtilities } from 'application/Home/Admin/Utilities/Dashboard';
import { AdminManageUsers } from 'application/Home/Admin/Utilities/ManageUsers/Dashboard';
import AdminSettings from 'application/Home/Admin/Utilities/Settings/Settings';
import AdminWebhooks from 'application/Home/Admin/Utilities/Webhooks/Dashboard';
import { AdminVendorIncidents } from 'application/Home/Admin/VendorIncidents/Dashboard';
import { ClientIntegrations as WorkatoClientIntegrations } from 'application/Home/Admin/Workato/ClientIntegrations';
import { SaasOpsActionDashboard } from 'application/Home/Admin/Workato/SaasOpsActionDashboard';

/*  Global Admin  */
import { GlobalApplicationDashboard } from 'application/Home/GlobalAdmin/Applications/Dashboard';
import GlobalCategory from 'application/Home/GlobalAdmin/Category/Dashboard';
import { GlobalConfigure } from 'application/Home/GlobalAdmin/Configure/Configure';
import { Playground } from 'application/Home/GlobalAdmin/Dashboard';
import GlobalNotes from 'application/Home/GlobalAdmin/Notes/Dashboard';
import { GlobalPublisher } from 'application/Home/GlobalAdmin/Publisher/Publisher';
import { FormBuilder } from 'application/Home/GlobalAdmin/SaasOps';
import { ManageManifestsDashboard } from 'application/Home/GlobalAdmin/SaasOps/ManageManifests/Dashboard';
import { GlobalTags } from 'application/Home/GlobalAdmin/Tags/Tags';
import { TenantPage } from 'application/Home/GlobalAdmin/Tenant/Components/TenantPage';
import { GlobalTenant } from 'application/Home/GlobalAdmin/Tenant/DashboardTenant';
import GlobalUser from 'application/Home/GlobalAdmin/User/User';
import GlobalVendorIncident from 'application/Home/GlobalAdmin/VendorIncident/Dashboard';

/*  Home  */
import { Home } from 'application/Home/Home';

/*  Partner Hub  */
import { ANMTrial } from 'application/Home/Partner/ANMTrial/ANMTrial';
import PartnerApps from 'application/Home/Partner/Applications/Dashboard';
import { PartnerClientsDashboard } from 'application/Home/Partner/Clients/Dashboard';
import PartnerDashboard from 'application/Home/Partner/Containers/Dashboard';
import { PartnerContracts } from 'application/Home/Partner/Contracts/Dashboard';
import { HubSettings } from 'application/Home/Partner/HubSettings/Dashboard';
import { PartnerIntegrationsDashboard } from 'application/Home/Partner/Integrations/Dashboard';
import API from 'application/Home/Partner/Integrations/Pages/API';
import ATRMM from 'application/Home/Partner/Integrations/Pages/ATRMM';
import { Acronis } from 'application/Home/Partner/Integrations/Pages/Acronis';
import { Addigy } from 'application/Home/Partner/Integrations/Pages/Addigy';
import AteraRMM from 'application/Home/Partner/Integrations/Pages/AteraRMM';
import CWAutomate from 'application/Home/Partner/Integrations/Pages/CWAutomate';
import CWManage from 'application/Home/Partner/Integrations/Pages/CWManage';
import { ConnectWise } from 'application/Home/Partner/Integrations/Pages/ConnectWise';
import GenericEmail from 'application/Home/Partner/Integrations/Pages/GenericEmail';
import { Intune } from 'application/Home/Partner/Integrations/Pages/Intune';
import { Jamf } from 'application/Home/Partner/Integrations/Pages/Jamf';
import KaseyaVSA from 'application/Home/Partner/Integrations/Pages/KaseyaVSA';
import LCI from 'application/Home/Partner/Integrations/Pages/LCI';
import NAble from 'application/Home/Partner/Integrations/Pages/NAble';
import NinjaOne from 'application/Home/Partner/Integrations/Pages/NinjaOne';
import SyncroMSP from 'application/Home/Partner/Integrations/Pages/SyncroMSP';
import { UnifiedAgent } from 'application/Home/Partner/Integrations/Pages/UnifiedAgent';
import { PartnerManageUsers } from 'application/Home/Partner/ManageUsers/Dashboard';
import { OnboardingBase } from 'application/Home/Partner/Onboarding/OnboardingBase';
import { SalesDocs } from 'application/Home/Partner/SalesDocs/Dashboard';
import PartnerUtilities from 'application/Home/Partner/Utilities/Dashboard';
import { PartnerVendorIncidents } from 'application/Home/Partner/VendorIncidents/Dashboard';

/* Reports */
import { ReportsDashboard } from 'application/Home/Reports/ReportsDashboard';
import { ReportsExported } from 'application/Home/Reports/ReportsExported';
import { ReportsSetup } from 'application/Home/Reports/ReportsSetup';
import { ScheduledReports } from 'application/Home/Reports/ScheduledReports';
import { isAdminReportAtPartnerLevel } from 'application/Home/Reports/helpers';

/* User */
import { ConfigureSelfUser } from 'application/Home/User/ConfigureSelfUser/ConfigureSelfUser';
import { UserSetup } from 'application/Home/User/UserSetup';

/* Loading */
import { LoadingPage } from 'application/Loading/Loading';

/*  Login Routes  */
import CloseOauth2 from 'application/Login/CloseOauth2';
import OktaCallback from 'application/Login/Components/Okta/Callback';
import OktaLogin from 'application/Login/Components/Okta/Containers/Login';
import Logout from 'application/Login/Containers/Logout';
import { Login } from 'application/Login/Login';

/*  Shared  */
import { PermissionCheck } from 'application/Shared/Components/Core';
import CustomScript from 'application/Shared/Components/CustomScript/Containers/CustomScript';
import { PageNotFound } from 'application/Shared/Components/PageNotFound';
import { TrialExpiryJailPage } from 'application/Shared/Components/TrialExpiryJailPage';
import { TenantProvider } from 'application/Shared/Contexts/TenantContext';
import { Helpers } from 'application/Shared/Helpers';
import { Alerts, Permissions } from 'application/Shared/Pages';
import { AdminView, GlobalView, PartnerView } from 'application/Shared/Views';
import { UNIFIED_AGENT, hasFeature } from 'featureFlags/src';

/* React */
import React from 'react';
import { Navigate, Routes as ReactRouterRoutes, Route } from 'react-router';

/*  Components  */
import { ViewPricing } from './Components/ViewPricing';

/**
 * Route components no longer accept an array of strings for the path prop, so this function takes an
 * array of paths and renders an individual routes for each of them.
 * @param {JSX.element} element The JSX element to be rendered.
 * @param {string[]} paths The paths to render the element for.
 * @returns {Array<Route>} Array of react-router routes
 */
const renderMultiRoutes = ({ element, paths }) =>
    paths.map((path) => <Route key={path} path={path} element={element} />);

/**
 * Adds a wrapper to all the children routes.
 */
const Routes = ({ children, wrapper, ...props }) => {
    const wrappedChildren = React.Children.map(children, (child) => {
        // If there is no wrapper or the child is not a valid element, return the child.
        if (!wrapper || !React.isValidElement(child)) return child;

        return React.cloneElement(child, {
            // Wrap the child in the wrapper component.
            element: React.createElement(wrapper, {}, child.props.element)
        });
    });
    return <ReactRouterRoutes {...props}>{wrappedChildren}</ReactRouterRoutes>;
};

export const AppRoutes = ({ rerender, session }) => {
    if (session && !rerender && Helpers.isTrialExpired(session)) {
        return (
            <Routes>
                <Route
                    path="/home/viewPricing"
                    element={<ViewPricing trialExpired />}
                />
                <Route path="/logout" element={<Logout />} />
                <Route
                    path="/home/trialExpired"
                    element={<TrialExpiryJailPage />}
                />
                <Route
                    path="*"
                    element={<Navigate to="/home/trialExpired" replace />}
                />
            </Routes>
        );
    }

    return (
        <Routes wrapper={TenantProvider}>
            {/* Login Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/close" element={<CloseOauth2 />} />
            <Route path="/loading" element={<LoadingPage />} />
            <Route path="/okta/login" element={<OktaLogin />} />
            <Route path="/okta/callback" element={<OktaCallback />} />

            {renderMultiRoutes({
                element: session && !rerender ? <Home /> : <Login />,
                paths: ['/', '/home']
            })}

            {/*
                ******
                Routes that only require a session (no permissions)
                ******
            */}
            <Route
                element={
                    <PermissionCheck
                        render={() => (
                            <AdminView>
                                <UserSetup />
                            </AdminView>
                        )}
                    />
                }
                path="/home/setup"
            />
            <Route
                element={
                    <PermissionCheck
                        render={() => (
                            <PartnerView>
                                <UserSetup />
                            </PartnerView>
                        )}
                    />
                }
                path="/partner/home/setup"
            />
            <Route
                element={<PermissionCheck Component={ViewPricing} />}
                path="/home/viewPricing"
            />

            {/* Onboarding Routes */}
            <Route
                path="/partner/:partnerId/onboarding/:currentType?/:currentStep?/:currentSelection?"
                element={<PermissionCheck Component={OnboardingBase} />}
            />

            {/* ANM trial Routes */}
            <Route
                path="/partner/:partnerId/anmTrial"
                element={
                    <PermissionCheck
                        Component={ANMTrial}
                        requiredPermissions={[
                            { required: ['partner', 'system_admin'] }
                        ]}
                    />
                }
            />

            {/*
                ******
                Routes that require a session with specific permissions
                ******
            */}
            <Route
                path="/home/configureSelfUser"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: 'personal_settings' }
                        ]}
                        render={() => (
                            <PartnerView page="personal" className="noPadding">
                                <ConfigureSelfUser />
                            </PartnerView>
                        )}
                    />
                }
            />

            <Route
                path="/admin/:clientId/configureSelfUser"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: 'personal_settings' }
                        ]}
                        render={() => (
                            <AdminView page="personal" className="noPadding">
                                <ConfigureSelfUser />
                            </AdminView>
                        )}
                    />
                }
            />

            {/* Partner Reports */}
            {/* This implementation will redirect users to the new route when the
            old route is accessed. */}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        render={({ match: { params } }) => (
                            <Navigate
                                to={`/partner/${params.partnerId}/reports/partnerReportSelection`}
                                replace
                            />
                        )}
                    />
                ),
                paths: ['/partner/:partnerId/reports/reportSelection']
            })}
            <Route
                path="/partner/:partnerId/reports/partnerReportSelection"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_availablePartnerReports">
                                <ReportsDashboard type="partner" />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/reports/adminReportSelection"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_availableAdminReports">
                                <ReportsDashboard type="admin" />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/reports/:reportType"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: [
                                    'partner',
                                    'reporting_organizational',
                                    'reporting_personal',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={({ match: { params } }) => {
                            const { clientId, reportType } = params || {};

                            const isAdminReport = isAdminReportAtPartnerLevel({
                                clientId,
                                reportType
                            });

                            const page = isAdminReport
                                ? 'partner_availableAdminReports'
                                : 'partner_availablePartnerReports';

                            return (
                                <PartnerView page={page}>
                                    <ReportsSetup />
                                </PartnerView>
                            );
                        }}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/reports/:reportType/summary"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: [
                                    'partner',
                                    'reporting_organizational',
                                    'reporting_personal',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={({ match: { params } }) => {
                            const { clientId, reportType } = params || {};

                            const isAdminReport = isAdminReportAtPartnerLevel({
                                clientId,
                                reportType
                            });

                            const page = isAdminReport
                                ? 'partner_availableAdminReports'
                                : 'partner_availablePartnerReports';

                            return (
                                <PartnerView page={page}>
                                    <ReportsExported />
                                </PartnerView>
                            );
                        }}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/reports/scheduledReports"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_scheduledReports">
                                <ScheduledReports />
                            </PartnerView>
                        )}
                    />
                }
            />

            {/* Client Reports */}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'partner',
                                    'reporting_organizational',
                                    'reporting_personal',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="admin_availableReports">
                                <ReportsDashboard type="admin" />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/reports/reportSelection',
                    '/admin/:clientId/reports/reportSelection'
                ]
            })}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: [
                                    'partner',
                                    'reporting_organizational',
                                    'reporting_personal',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="admin_availableReports">
                                <ReportsSetup />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/reports/:reportType?',
                    '/admin/:clientId/reports/:reportType?'
                ]
            })}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: [
                                    'partner',
                                    'reporting_organizational',
                                    'reporting_personal',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="admin_availableReports">
                                <ReportsExported />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/reports/:reportType/summary',
                    '/admin/:clientId/reports/:reportType/summary'
                ]
            })}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: [
                                    'partner',
                                    'reporting_organizational',
                                    'reporting_personal',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="admin_scheduledReports">
                                <ScheduledReports />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/reports/scheduledReports',
                    '/admin/:clientId/reports/scheduledReports'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: [
                                    'reporting_organizational',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="breaches">
                                <AdminVendorIncidents />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/breaches',
                    '/admin/:clientId/breaches'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="notes">
                                <AdminNotes />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/notes',
                    '/admin/:clientId/notes'
                ]
            })}

            {/* This implementation will redirect users to the new route (pathfinder/admin dashboard) when the
            old insights route is accessed. */}
            {/* TODO: Implement the same permissions as the admin dashboard (which is another TODO by itself) */}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        render={({ match: { params } }) => (
                            <Navigate
                                to={
                                    params.partnerId
                                        ? `/partner/${params.partnerId}/admin/${params.clientId}`
                                        : `/admin/${params.clientId}`
                                }
                                replace
                            />
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/insights',
                    '/admin/:clientId/insights'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[{ required: ['workflow'] }]}
                        render={() => (
                            <AdminView page="alerts">
                                <Alerts />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/alerts/:tab?',
                    '/admin/:clientId/alerts/:tab?'
                ]
            })}

            {/* System Admin Routes */}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        // Re: https://auviknetworks.atlassian.net/browse/SAAS-436
                        // Commenting out these permissions for now. Before restructuring routes in https://github.com/saaslioco/opus/pull/503,
                        // This route had no permissions on it, and it seemed like an error. Going to revert to that for now.
                        // TODO: revisit these permissions. See https://auviknetworks.atlassian.net/browse/SAAS-456 for more info.
                        // requiredPermissions={[
                        //     {
                        //         required: ['system_admin', 'system_admin'],
                        //         operator: 'or'
                        //     }
                        // ]}
                        render={() => (
                            <AdminView page="dashboard">
                                <Pathfinder />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId',
                    '/admin/:clientId'
                ]
            })}

            {/* This implementation will redirect users to the new route when the
            old route is accessed. */}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        render={({ match: { params } }) => (
                            <Navigate
                                to={`/partner/${params.partnerId}/admin/${params.clientId}/applications`}
                                replace
                            />
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/applications/inventory',
                    '/partner/:partnerId/admin/:clientId/applications/insights'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_applications',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="applications">
                                <AdminApplications />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/applications',
                    '/admin/:clientId/applications'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_applications',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => <AdminApplication />}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/application/:applicationId/:tab?',
                    '/admin/:clientId/application/:applicationId/:tab?'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'contract_management',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="contracts">
                                <AdminContractsDashboard />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/contracts/:tab?',
                    '/admin/:clientId/contracts/:tab?'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: ['system_users', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="users">
                                <AdminUsers />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/users',
                    '/admin/:clientId/users'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: ['system_users', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="accounts">
                                <AdminUsersAccounts />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/accounts',
                    '/admin/:clientId/accounts'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: ['system_users', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="providerUsers">
                                <AdminProvider component={ProviderUsers} />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/providerUsers',
                    '/admin/:clientId/providerUsers'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: ['system_users', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="providerGroups">
                                <AdminProvider component={ProviderGroups} />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/providerGroups',
                    '/admin/:clientId/providerGroups'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: ['system_users', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="devices">
                                <AdminUsersDevices />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/devices',
                    '/admin/:clientId/devices'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: ['system_users', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="user">
                                <AdminUserDashboard />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/user/:userId/:tab?',
                    '/admin/:clientId/user/:userId/:tab?'
                ]
            })}

            {/* Configure Page Routes */}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            }
                        ]}
                        Component={AdminUtilities}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/configure',
                    '/admin/:clientId/configure'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <AdminSettings />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/clientSettings',
                    '/admin/:clientId/clientSettings'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_permissions'
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <Permissions fromAdminUtilities />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/permissions',
                    '/admin/:clientId/permissions'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_permissions'
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <AdminManageUsers />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/manageUsers/:tab?',
                    '/admin/:clientId/manageUsers/:tab?'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_integrations'
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <AdminWebhooks />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/webhooks',
                    '/admin/:clientId/webhooks'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_integrations'
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <ProviderIntegration />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/identityManagement/:tab?',
                    '/admin/:clientId/identityManagement/:tab?'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_integrations'
                            }
                        ]}
                        render={(props) => {
                            const { clientId } = props.match.params;
                            return (
                                <AdminView page="configure">
                                    <WorkatoClientIntegrations
                                        clientId={clientId}
                                    />
                                </AdminView>
                            );
                        }}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/saasOpsIntegrations',
                    '/partner/:partnerId/admin/:clientId/saasopsintegrations',
                    '/admin/:clientId/saasOpsIntegrations',
                    '/admin/:clientId/saasopsintegrations'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_integrations'
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <Domains />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/domains',
                    '/admin/:clientId/domains'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_bulk_editor'
                            }
                        ]}
                        Component={AdminBulkEditor}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/bulk',
                    '/admin/:clientId/bulk'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_bulk_editor'
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <TagEditor />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/tags',
                    '/admin/:clientId/tags'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                required: 'system_deployment'
                            }
                        ]}
                        render={() => (
                            <AdminView page="configure">
                                <AdminExtension />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/extension',
                    '/admin/:clientId/extension'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'system_admin']
                            },
                            {
                                operator: 'or',
                                required: [
                                    'system_integrations',
                                    'system_new_user_popup',
                                    'system_permissions',
                                    'system_bulk_editor',
                                    'system_deployment',
                                    'system_admin'
                                ]
                            },
                            {
                                operator: 'or',
                                required: ['application_logs', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <AdminView page="logs">
                                <AdminLogs />
                            </AdminView>
                        )}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/logs',
                    '/admin/:clientId/logs'
                ]
            })}

            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                operator: 'or',
                                required: ['system_admin', 'client_admin']
                            }
                        ]}
                        render={({ match }) => {
                            const { action } = match.params;
                            return (
                                <AdminView
                                    // when the action changes, we want to ensure all children are re-rendered.
                                    key={action}
                                    page={action}
                                    className="noPadding"
                                >
                                    <SaasOpsActionDashboard />
                                </AdminView>
                            );
                        }}
                    />
                ),
                paths: [
                    '/partner/:partnerId/admin/:clientId/saasOps/:action',
                    '/admin/:clientId/saasOps/:action'
                ]
            })}

            <Route
                path="/partner/:partnerId/salesHub"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner']
                            },
                            {
                                operator: 'or',
                                required: ['partner_sales_hub', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_sales_hub">
                                <SalesDocs />
                            </PartnerView>
                        )}
                    />
                }
            />
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={(props) => {
                            const { partnerId } = props.match.params;

                            // The key was added to PartnerDashboard below to accommodate the new multi-tenant selector and it not re-rendering
                            // this route when changing tenants. This forces PartnerDashboard to re-render whenever partnerId changes.
                            return (
                                <PartnerView page="partner_dashboard">
                                    <PartnerDashboard key={partnerId} />
                                </PartnerView>
                            );
                        }}
                    />
                ),
                paths: ['/partner/:partnerId', '/partner/:partnerId/dashboard']
            })}

            <Route
                path="/partner/:partnerId/manageUsers/:tab?"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            },
                            {
                                required: 'system_users'
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_users">
                                <PartnerManageUsers />
                            </PartnerView>
                        )}
                    />
                }
            />

            <Route
                path="/partner/:partnerId/organizations"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_organizations">
                                <PartnerClientsDashboard />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/breaches"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_breaches">
                                <PartnerVendorIncidents />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/:tab?"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <PartnerIntegrationsDashboard />
                            </PartnerView>
                        )}
                    />
                }
            />

            <Route
                path="/partner/:partnerId/tags"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_tag">
                                <TagEditor />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/configure"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_utilities">
                                <PartnerUtilities />
                            </PartnerView>
                        )}
                    />
                }
            />

            <Route
                path="/partner/:partnerId/applicationSettings"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_application_settings">
                                <PartnerApps />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/hubSettings/:tab?"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_settings">
                                <HubSettings />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/contracts"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_contracts">
                                <PartnerContracts />
                            </PartnerView>
                        )}
                    />
                }
            />

            <Route
                path="/partner/:partnerId/alerts/:tab?"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_alerts">
                                <Alerts partner />
                            </PartnerView>
                        )}
                    />
                }
            />

            <Route
                path="/partner/:partnerId/integrations/atera"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <AteraRMM session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/cw_manage"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <CWManage session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/acronis"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <Acronis />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/addigy"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <Addigy />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/jamf"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <Jamf />
                            </PartnerView>
                        )}
                    />
                }
            />
            {hasFeature(UNIFIED_AGENT) && (
                <Route
                    path="/partner/:partnerId/integrations/unified_agent"
                    element={
                        <PermissionCheck
                            requiredPermissions={[
                                {
                                    required: ['partner', 'system_admin']
                                }
                            ]}
                            render={() => (
                                <PartnerView page="partner_integrations">
                                    <UnifiedAgent />
                                </PartnerView>
                            )}
                        />
                    }
                />
            )}
            <Route
                path="/partner/:partnerId/integrations/cw_automate"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <CWAutomate session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/at_rmm"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <ATRMM session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/syncro_msp"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <SyncroMSP session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/n_able"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <NAble session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/ninja"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <NinjaOne session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/custom_script"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <CustomScript />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/generic_email"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <GenericEmail session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/lci"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <LCI session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/api"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <API session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/kaseyaVSA"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <KaseyaVSA session={session} />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/intune"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <Intune />
                            </PartnerView>
                        )}
                    />
                }
            />
            <Route
                path="/partner/:partnerId/integrations/connectwise"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            {
                                required: ['partner', 'system_admin']
                            }
                        ]}
                        render={() => (
                            <PartnerView page="partner_integrations">
                                <ConnectWise />
                            </PartnerView>
                        )}
                    />
                }
            />

            {/* Global Admin Routes */}
            {renderMultiRoutes({
                element: (
                    <PermissionCheck
                        requiredPermissions={[
                            { required: 'global_system_admin' }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminTenants">
                                <GlobalTenant />
                            </GlobalView>
                        )}
                    />
                ),
                paths: ['/globaladmin', '/globaladmin/tenant']
            })}

            <Route
                path="/globaladmin/tenant/:tenantId/:tab?"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminTenants">
                                <TenantPage />
                            </GlobalView>
                        )}
                    />
                }
            />

            <Route
                path="/globaladmin/application"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminApplications">
                                <GlobalApplicationDashboard />
                            </GlobalView>
                        )}
                    />
                }
            />

            <Route
                path="/globaladmin/category"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        Component={GlobalCategory}
                    />
                }
            />

            <Route
                path="/globaladmin/user"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: 'global_system_admin' }
                        ]}
                        Component={GlobalUser}
                    />
                }
            />

            <Route
                path="/globaladmin/vendorIncident"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        Component={GlobalVendorIncident}
                    />
                }
            />

            <Route
                path="/globaladmin/notes"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminNotes">
                                <GlobalNotes />
                            </GlobalView>
                        )}
                    />
                }
            />

            <Route
                path="/globaladmin/publisher"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminPublisher">
                                <GlobalPublisher />
                            </GlobalView>
                        )}
                    />
                }
            />

            <Route
                path="/globaladmin/configure"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminConfigure">
                                <GlobalConfigure />
                            </GlobalView>
                        )}
                    />
                }
            />
            <Route
                path="/globaladmin/configure/tags"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminConfigure">
                                <GlobalTags />
                            </GlobalView>
                        )}
                    />
                }
            />
            <Route
                path="/globaladmin/configure/formbuilder"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminConfigure">
                                <FormBuilder />
                            </GlobalView>
                        )}
                    />
                }
            />
            <Route
                path="/globaladmin/configure/manifests"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="globalAdminConfigure">
                                <ManageManifestsDashboard />
                            </GlobalView>
                        )}
                    />
                }
            />

            <Route
                path="/globaladmin/dashboards/playground"
                element={
                    <PermissionCheck
                        requiredPermissions={[
                            { required: ['super_admin', 'global_system_admin'] }
                        ]}
                        render={() => (
                            <GlobalView page="dashboards">
                                <Playground />
                            </GlobalView>
                        )}
                    />
                }
            />

            <Route
                path="*"
                element={
                    session ? (
                        <PageNotFound />
                    ) : (
                        <Navigate to="/login" replace />
                    )
                }
            />
        </Routes>
    );
};
